import React from 'react'
import useConfigureAndSendTag from '../analytics/useConfigureAndSendTag'
import s from './MenuSubCategoryItem.less'
import SVGIcon from '../svg/SVGIcon'
import { navigateToSearchBySubcategory, navigateToPoisOnRouteBySubcategory } from '../../store/history/history.actions'
import { TAG_CLICK_CATEGORY_BAR } from '../analytics/analytics.tagids.constants'
import { APP_OR_SUBCAT_ID, CAT_ID } from '../analytics/ClickTagsService'
import { useAction } from '../utils/react-redux'
import classnames from 'classnames'
import { iconClassName, itemClassName } from './CategorySubMenuStyle'
import { useSelector } from 'react-redux'
import { selectIsPageElligibleForPoisOnRoute } from '../../store/history/history.selectors'

const MenuSubCategoryItem = ({ id, categoryId, iconId, label, onClick }) => {
  const execNavigateToSmrBySubCategory = useAction(navigateToPoisOnRouteBySubcategory)
  const configureAndSendTag = useConfigureAndSendTag()
  const execNavigateToSearchBySubcategory = useAction(navigateToSearchBySubcategory)

  const isPageElligibleForPoisOnRoute = useSelector(selectIsPageElligibleForPoisOnRoute)

  const onSubCategoryClick = () => e => {
    configureAndSendTag({
      type: TAG_CLICK_CATEGORY_BAR,
      tagInfo: {
        [CAT_ID]: categoryId,
        [APP_OR_SUBCAT_ID]: id
      }
    })

    if (isPageElligibleForPoisOnRoute) {
      execNavigateToSmrBySubCategory(id)
    } else {
      execNavigateToSearchBySubcategory(id)
    }
    onClick()
  }

  return (
    <li className={classnames(s.root, itemClassName)} onClick={onSubCategoryClick()}>
      <span className={classnames(s.subcategoryIcon, iconClassName)}>
        <SVGIcon icon={iconId} />
      </span>
      <span className={s.label}>{label}</span>
    </li>
  )
}

export default MenuSubCategoryItem
